export class OrderTokenManager {
  
  private static readonly ORDER_TOKEN_KEY = 'order_token';
  

  /**
   * Gets the current stored order token value
   */
  static get token(): string | null {
    try {
      return localStorage.getItem(OrderTokenManager.ORDER_TOKEN_KEY);
    } catch {
      return null;
    }
  }

  /**
   * Sets the order token value
   */
  static set token(key: string | null) {
    try {
      localStorage.setItem(OrderTokenManager.ORDER_TOKEN_KEY, key ?? '');
    } catch {
      console.error('No access to local storage granted, some of the widget functionalities will be limited.');
    }
  }
}
